import { any } from 'ramda';

export const ROLE_NAMES = {
  PATERSON_AND_COOKE: 'patersonandcooke',
  ADMINISTRATOR: 'administrator',
  LAB: 'lab',
} as const;

export const hasRole = (roles: string[], role: string): boolean => any((r: string) => r.toLowerCase() === role.toLowerCase(), roles);

export const isPcUser = (roles: string[]): boolean => hasRole(roles, ROLE_NAMES.PATERSON_AND_COOKE);
export const isAdminUser = (roles: string[]): boolean => hasRole(roles, ROLE_NAMES.ADMINISTRATOR);
export const isLabUser = (roles: string[]): boolean => hasRole(roles, ROLE_NAMES.LAB);
export const isLabOnlyUser = (roles: string[]): boolean => isLabUser(roles) && !isAdminUser(roles) && !isPcUser(roles);
